import { arizonaIsoDate } from "./arizona-date.js";

export { arizonaIsoDate } from "./arizona-date.js";

const SLIDER_WINDOW_DAYS = 30;
const REPORT_MAP_DATE_LOCALES = Object.freeze({
  EN: "en-US",
  ES: "es-US",
});

export function defaultReportMapTimeWindow(now = new Date()) {
  const selectedDate = arizonaIsoDate(now);
  const startDate = addDays(selectedDate, -SLIDER_WINDOW_DAYS);
  return {
    windowStartDate: startDate,
    windowEndDate: selectedDate,
    startDate,
    selectedDate,
  };
}

export function addDays(isoDate, days) {
  const date = utcDateFromIsoDate(isoDate);
  date.setUTCDate(date.getUTCDate() + days);
  return isoDateFromUtcDate(date);
}

export function sliderDateForIndex(startDate, index) {
  const dayIndex = Math.max(0, Math.min(SLIDER_WINDOW_DAYS, Number.parseInt(index, 10) || 0));
  return addDays(startDate, dayIndex);
}

export function sliderIndexForDate(startDate, selectedDate) {
  const start = utcDateFromIsoDate(startDate);
  const selected = utcDateFromIsoDate(selectedDate);
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  const diff = Math.round((selected.getTime() - start.getTime()) / millisecondsPerDay);
  return Math.max(0, Math.min(SLIDER_WINDOW_DAYS, diff));
}

// The report map always spans the window start date through the selected day; there is no
// single-day mode.
export function filterRecordsForReportMapTimeWindow(records, window) {
  const { startDate, selectedDate } = window;
  return records.filter((record) => {
    const submittedDate = arizonaIsoDate(record.submitted_at);
    return submittedDate >= startDate && submittedDate <= selectedDate;
  });
}

export function formatReportMapDate(isoDate, language = "EN") {
  return reportMapDateFormatter(language, true).format(utcDateFromIsoDate(isoDate));
}

export function formatReportMapRange(startDate, selectedDate, language = "EN", through = "through") {
  const startYear = startDate.slice(0, 4);
  const selectedYear = selectedDate.slice(0, 4);
  const startLabel = startYear === selectedYear
    ? reportMapDateFormatter(language, false).format(utcDateFromIsoDate(startDate))
    : formatReportMapDate(startDate, language);
  return `${startLabel} ${through} ${formatReportMapDate(selectedDate, language)}`;
}

export function sliderWindowDays() {
  return SLIDER_WINDOW_DAYS;
}

function utcDateFromIsoDate(isoDate) {
  const [year, month, day] = String(isoDate).split("-").map((part) => Number.parseInt(part, 10));
  return new Date(Date.UTC(year, month - 1, day));
}

function reportMapDateFormatter(language, includeYear) {
  return new Intl.DateTimeFormat(REPORT_MAP_DATE_LOCALES[language] || REPORT_MAP_DATE_LOCALES.EN, {
    timeZone: "UTC",
    month: "short",
    day: "numeric",
    ...(includeYear ? { year: "numeric" } : {}),
  });
}

function isoDateFromUtcDate(date) {
  return date.toISOString().slice(0, 10);
}
